"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _myDatePicker = _interopRequireDefault(require("@/components/myDatePicker"));
var _finance = require("@/api/finance");
var _default = {
  components: {
    customPage: _customPage.default,
    myDatePicker: _myDatePicker.default
  },
  data: function data() {
    return {
      searchForm: {
        orderNo: '',
        goodsName: '',
        orderStatus: '',
        orderCreateTime: ''
      },
      tableData: [],
      total: 0,
      selectList: [],
      stateData: [{
        title: '当月应收期数/金额',
        content: '订单当月租期商户应该收取用户的期数/金额'
      }, {
        title: '当月实收金额',
        content: '订单当月租期商户实际收取用户的金额'
      }, {
        title: '当月逾期金额',
        content: '当月逾期金额=当月应收金额-当月实收金额，即订单当月租期还未完结，已到付款期却未付款的金额'
      }, {
        title: '累计应收期数/金额',
        content: '截止到当月商户应该收取用户的期数/金额'
      }, {
        title: '累计实收金额',
        content: '截止到当月商户实际收取用户的总金额'
      }, {
        title: '累计逾期金额',
        content: '累计逾期金额=累计应收金额-累计实收金额，即订单整个租期还未完结，已到付款期却未付款的金额'
      }, {
        title: '应收账款',
        content: '应收账款=总租金-累计实收金额，即租期未支付的总金额'
      }, {
        title: '违约金额',
        content: '违约金额是订单整个租期已结束，仍欠款未还的金额'
      }]
    };
  },
  methods: {
    goToOrder: function goToOrder(orderId) {
      if (orderId) {
        this.$router.push({
          name: 'orderList',
          params: {
            orderId: orderId
          }
        });
      }
    },
    // 获取数据
    getList: function getList() {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      (0, _finance.financeEquipmentList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.tableData = res.data || [];
        _this.total = res.total || 0;
      });
    },
    // 查询
    search: function search() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal !== 'error') {
        this.searchForm.orderCreateTime = pickerVal;
        this.$refs.customPage.page = 1;
        this.getList();
      }
    },
    // 重置
    reset: function reset() {
      if (this.$refs.myDatePicker) {
        this.$refs.myDatePicker.reset();
      }
      this.searchForm = {
        orderNo: '',
        goodsName: '',
        orderStatus: '',
        orderCreateTime: ''
      };
      this.getList();
    },
    // 导出
    exportFile: function exportFile() {
      var pickerVal = this.$refs.myDatePicker.getVal();
      if (pickerVal !== 'error') {
        this.searchForm.orderCreateTime = pickerVal;
        (0, _finance.equipmentListExport)(this.searchForm);
      }
    },
    getSelect: function getSelect() {
      var _this2 = this;
      (0, _finance.getOrderStatus)().then(function (res) {
        var list = [];
        for (var key in res) {
          list.push({
            id: key,
            name: res[key]
          });
        }
        _this2.selectList = list || [];
      });
    }
  },
  mounted: function mounted() {
    this.getSelect();
    this.getList();
  }
};
exports.default = _default;